import * as selector from './selectors';

export const oldSignatoriesSelector = selector;
export * from './actions';
export * from './service.actions';
export { default as reducer } from './reducer';
